import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';

export const Wrapper = styled(Container)`
  iframe {
    width: 100%;
    min-height: 840px;
    ${media.largeScreen`
      min-height: 542px;
    `}
    ${media.mediumScreen`
      min-height: 480px;
    `}
    ${media.smallScreen`
      min-height: 380px;
    `}
  }
`;
